// constants/gabonGeographicData.ts
// Données géographiques officielles du Gabon

export interface Country {
    id: number;
    name: string;
    code: string;
}

export interface Province {
    id: number;
    name: string;
    country_id: number;
}

export interface Department {
    id: number;
    name: string;
    province_id: number;
    chef_lieu: string;
    population: number;
}

export interface City {
    id: number;
    name: string;
    department_id: number;
    province_id: number;
}

export interface GabonGeographicData {
    provinces: Province[];
    departments: Department[];
    cities: City[];
}

// ==========================================
// PAYS DU MONDE (SÉLECTION)
// ==========================================
export const WORLD_COUNTRIES: Country[] = [
    { id: 1, name: 'Gabon', code: 'GA' },
    { id: 2, name: 'France', code: 'FR' },
    { id: 3, name: 'Cameroun', code: 'CM' },
    { id: 4, name: 'Congo', code: 'CG' },
    { id: 5, name: 'République Démocratique du Congo', code: 'CD' },
    { id: 6, name: 'Guinée Équatoriale', code: 'GQ' },
    { id: 7, name: 'Tchad', code: 'TD' },
    { id: 8, name: 'République Centrafricaine', code: 'CF' },
    { id: 9, name: 'Angola', code: 'AO' },
    { id: 10, name: 'São Tomé-et-Príncipe', code: 'ST' },
    { id: 11, name: 'Canada', code: 'CA' },
    { id: 12, name: 'États-Unis', code: 'US' },
    { id: 13, name: 'Allemagne', code: 'DE' },
    { id: 14, name: 'Espagne', code: 'ES' },
    { id: 15, name: 'Italie', code: 'IT' },
    { id: 16, name: 'Belgique', code: 'BE' },
    { id: 17, name: 'Suisse', code: 'CH' },
    { id: 18, name: 'Royaume-Uni', code: 'GB' },
    { id: 19, name: 'Maroc', code: 'MA' },
    { id: 20, name: 'Tunisie', code: 'TN' },
    { id: 21, name: 'Algérie', code: 'DZ' },
    { id: 22, name: 'Sénégal', code: 'SN' },
    { id: 23, name: 'Côte d\'Ivoire', code: 'CI' },
    { id: 24, name: 'Mali', code: 'ML' },
    { id: 25, name: 'Burkina Faso', code: 'BF' },
    { id: 26, name: 'Niger', code: 'NE' },
    { id: 27, name: 'Mauritanie', code: 'MR' },
    { id: 28, name: 'Togo', code: 'TG' },
    { id: 29, name: 'Bénin', code: 'BJ' },
    { id: 30, name: 'Ghana', code: 'GH' },
    { id: 31, name: 'Nigéria', code: 'NG' },
    { id: 32, name: 'Kenya', code: 'KE' },
    { id: 33, name: 'Afrique du Sud', code: 'ZA' },
    { id: 34, name: 'Madagascar', code: 'MG' },
    { id: 35, name: 'Maurice', code: 'MU' },
    { id: 36, name: 'La Réunion', code: 'RE' },
    { id: 37, name: 'Mayotte', code: 'YT' },
    { id: 38, name: 'Guyane française', code: 'GF' },
    { id: 39, name: 'Martinique', code: 'MQ' },
    { id: 40, name: 'Guadeloupe', code: 'GP' }
];

// ==========================================
// DONNÉES OFFICIELLES COMPLÈTES DU GABON
// ==========================================
export const GABON_GEOGRAPHIC_DATA: GabonGeographicData = {
    provinces: [
        { id: 1, name: 'Estuaire', country_id: 1 },
        { id: 2, name: 'Haut-Ogooué', country_id: 1 },
        { id: 3, name: 'Moyen-Ogooué', country_id: 1 },
        { id: 4, name: 'Ngounié', country_id: 1 },
        { id: 5, name: 'Nyanga', country_id: 1 },
        { id: 6, name: 'Ogooué-Ivindo', country_id: 1 },
        { id: 7, name: 'Ogooué-Lolo', country_id: 1 },
        { id: 8, name: 'Ogooué-Maritime', country_id: 1 },
        { id: 9, name: 'Woleu-Ntem', country_id: 1 }
    ],
    departments: [
        // === ESTUAIRE (Province 1) ===
        { id: 1, name: 'Akanda', province_id: 1, chef_lieu: 'Akanda', population: 703940 },
        { id: 2, name: 'Komo', province_id: 1, chef_lieu: 'Kango', population: 17575 },
        { id: 3, name: 'Komo-Mondah', province_id: 1, chef_lieu: 'Ntoum', population: 90096 },
        { id: 4, name: 'Komo-Océan', province_id: 1, chef_lieu: 'Ndzomoe', population: 553 },
        { id: 5, name: 'Noya', province_id: 1, chef_lieu: 'Cocobeach', population: 4225 },

        // === HAUT-OGOOUÉ (Province 2) ===
        { id: 6, name: 'Bayi-Brikolo', province_id: 2, chef_lieu: 'Aboumi', population: 1998 },
        { id: 7, name: 'Djouori-Agnili', province_id: 2, chef_lieu: 'Bongoville', population: 4210 },
        { id: 8, name: 'Djué', province_id: 2, chef_lieu: 'Onga', population: 2178 },
        { id: 9, name: 'Lékabi-Léwolo', province_id: 2, chef_lieu: 'Moanda', population: 64569 },
        { id: 10, name: 'Lékoko', province_id: 2, chef_lieu: 'Bakoumba', population: 4920 },
        { id: 11, name: 'Lékoni-Lékori', province_id: 2, chef_lieu: 'Akieni', population: 10028 },
        { id: 12, name: 'Lemboumbi-Leyou', province_id: 2, chef_lieu: 'Moanda', population: 64569 },
        { id: 13, name: 'Lékabi-Léwolo', province_id: 2, chef_lieu: 'Ngouoni', population: 4914 },
        { id: 14, name: 'Mpassa', province_id: 2, chef_lieu: 'Franceville', population: 129694 },
        { id: 15, name: 'Ogooué-Létili', province_id: 2, chef_lieu: 'Boumango', population: 2791 },
        { id: 16, name: 'Plateaux', province_id: 2, chef_lieu: 'Lékoni', population: 9054 },
        { id: 17, name: 'Sébé-Brikolo', province_id: 2, chef_lieu: 'Okondja', population: 16443 },

        // === MOYEN-OGOOUÉ (Province 3) ===
        { id: 18, name: 'Abanga-Bigné', province_id: 3, chef_lieu: 'Ndjolé', population: 14941 },
        { id: 19, name: 'Ogooué et des Lacs', province_id: 3, chef_lieu: 'Lambaréné', population: 54346 },


        // === NGOUNIÉ (Province 4) ===
        { id: 20, name: 'Boumi-Louetsi', province_id: 4, chef_lieu: 'Mbigou', population: 13223 },
        { id: 21, name: 'Dola', province_id: 4, chef_lieu: 'Ndendé', population: 6979 },
        { id: 22, name: 'Douya-Onoye', province_id: 4, chef_lieu: 'Mouila', population: 37699 },
        { id: 23, name: 'Louetsi-Bibaka', province_id: 4, chef_lieu: 'Malinga', population: 2734 },
        { id: 24, name: 'Louetsi-Wano', province_id: 4, chef_lieu: 'Lébamba', population: 9750 },
        { id: 25, name: 'Mougalaba', province_id: 4, chef_lieu: 'Guiétsou', population: 1490 },
        { id: 26, name: 'Ndolou', province_id: 4, chef_lieu: 'Mandji', population: 5727 },
        { id: 27, name: 'Ogoulou', province_id: 4, chef_lieu: 'Mimongo', population: 8361 },
        { id: 28, name: 'Tsamba-Magotsi', province_id: 4, chef_lieu: 'Fougamou', population: 14875 },

        // === NYANGA (Province 5) ===
        { id: 29, name: 'Basse-Banio', province_id: 5, chef_lieu: 'Mayumba', population: 7192 },
        { id: 30, name: 'Douigny', province_id: 5, chef_lieu: 'Moabi', population: 5235 },
        { id: 31, name: 'Doutsila', province_id: 5, chef_lieu: 'Mabanda', population: 4623 },
        { id: 32, name: 'Haute-Banio', province_id: 5, chef_lieu: 'Ndindi', population: 1413 },
        { id: 33, name: 'Mongo', province_id: 5, chef_lieu: 'Moulengui-Binza', population: 2602 },
        { id: 34, name: 'Mougoutsi', province_id: 5, chef_lieu: 'Tchibanga', population: 31789 },

        // === OGOOUÉ-IVINDO (Province 6) ===
        { id: 35, name: 'Ivindo', province_id: 6, chef_lieu: 'Makokou', population: 31073 },
        { id: 36, name: 'Lopé', province_id: 6, chef_lieu: 'Booué', population: 12382 },
        { id: 37, name: 'Mvoung', province_id: 6, chef_lieu: 'Ovan', population: 4022 },
        { id: 38, name: 'Zadié', province_id: 6, chef_lieu: 'Mékambo', population: 15816 },

        // === OGOOUÉ-LOLO (Province 7) ===
        { id: 39, name: 'Lolo-Bouenguidi', province_id: 7, chef_lieu: 'Koulamoutou', population: 30643 },
        { id: 40, name: 'Lombo-Bouenguidi', province_id: 7, chef_lieu: 'Pana', population: 4635 },
        { id: 41, name: 'Mulundu', province_id: 7, chef_lieu: 'Lastoursville', population: 27750 },
        { id: 42, name: 'Offoué-Onoye', province_id: 7, chef_lieu: 'Iboundji', population: 2743 },

        // === OGOOUÉ-MARITIME (Province 8) ===
        { id: 43, name: 'Bendjé', province_id: 8, chef_lieu: 'Port-Gentil', population: 140747 },
        { id: 44, name: 'Etimboué', province_id: 8, chef_lieu: 'Omboué', population: 5723 },
        { id: 45, name: 'Ndougou', province_id: 8, chef_lieu: 'Gamba', population: 11092 },

        // === WOLEU-NTEM (Province 9) ===
        { id: 46, name: 'Haut-Como', province_id: 9, chef_lieu: 'Médouneu', population: 3403 },
        { id: 47, name: 'Haut-Ntem', province_id: 9, chef_lieu: 'Minvoul', population: 10838 },
        { id: 48, name: 'Ntem', province_id: 9, chef_lieu: 'Bitam', population: 49712 },
        { id: 49, name: 'Okano', province_id: 9, chef_lieu: 'Mitzic', population: 16630 },
        { id: 50, name: 'Woleu', province_id: 9, chef_lieu: 'Oyem', population: 74403 }
    ],
    cities: [
        // === ESTUAIRE ===
        // Akanda
        { id: 1, name: 'Libreville', department_id: 1, province_id: 1 },
        { id: 2, name: 'Akanda', department_id: 1, province_id: 1 },
        { id: 3, name: 'Owendo', department_id: 1, province_id: 1 },

        // Komo
        { id: 4, name: 'Kango', department_id: 2, province_id: 1 },

        // Komo-Mondah
        { id: 5, name: 'Ntoum', department_id: 3, province_id: 1 },

        // Komo-Océan
        { id: 6, name: 'Ndzomoe', department_id: 4, province_id: 1 },

        // Noya
        { id: 7, name: 'Cocobeach', department_id: 5, province_id: 1 },

        // === HAUT-OGOOUÉ ===
        // Mpassa
        { id: 8, name: 'Franceville', department_id: 14, province_id: 2 },

        // Lékabi-Léwolo
        { id: 9, name: 'Moanda', department_id: 9, province_id: 2 },
        { id: 10, name: 'Mounana', department_id: 9, province_id: 2 },

        // Lékoko
        { id: 11, name: 'Bakoumba', department_id: 10, province_id: 2 },

        // Sébé-Brikolo
        { id: 12, name: 'Okondja', department_id: 17, province_id: 2 },

        // Lékoni-Lékori
        { id: 13, name: 'Akieni', department_id: 11, province_id: 2 },
        { id: 14, name: 'Léconi', department_id: 11, province_id: 2 },

        // Plateaux
        { id: 15, name: 'Lékoni', department_id: 16, province_id: 2 },

        // Djué
        { id: 16, name: 'Onga', department_id: 8, province_id: 2 },

        // Djouori-Agnili
        { id: 17, name: 'Bongouville', department_id: 7, province_id: 2 },

        // === MOYEN-OGOOUÉ ===
        // Ogooué et des Lacs
        { id: 18, name: 'Lambaréné', department_id: 19, province_id: 3 },

        // Abanga-Bigné
        { id: 19, name: 'Ndjolé', department_id: 18, province_id: 3 },

        // === NGOUNIÉ ===
        // Douya-Onoye
        { id: 20, name: 'Mouila', department_id: 22, province_id: 4 },

        // Dola
        { id: 21, name: 'Ndendé', department_id: 21, province_id: 4 },

        // Boumi-Louetsi
        { id: 22, name: 'Mbigou', department_id: 20, province_id: 4 },

        // Ogoulou
        { id: 23, name: 'Mimongo', department_id: 27, province_id: 4 },

        // Louetsi-Wano
        { id: 24, name: 'Lébamba', department_id: 24, province_id: 4 },

        // Tsamba-Magotsi
        { id: 25, name: 'Fougamou', department_id: 28, province_id: 4 },

        // Ndolou
        { id: 26, name: 'Mandji', department_id: 26, province_id: 4 },

        // === NYANGA ===
        // Mougoutsi
        { id: 27, name: 'Tchibanga', department_id: 34, province_id: 5 },

        // Basse-Banio
        { id: 28, name: 'Mayumba', department_id: 29, province_id: 5 },

        // Mongo
        { id: 29, name: 'Moulengui-Binza', department_id: 33, province_id: 5 },

        // Haute-Banio
        { id: 30, name: 'Ndindi', department_id: 32, province_id: 5 },

        // Douigny
        { id: 31, name: 'Moabi', department_id: 30, province_id: 5 },

        // Doutsila
        { id: 32, name: 'Mabanda', department_id: 31, province_id: 5 },

        // === OGOOUÉ-IVINDO ===
        // Ivindo
        { id: 33, name: 'Makokou', department_id: 35, province_id: 6 },

        // Lopé
        { id: 34, name: 'Booué', department_id: 36, province_id: 6 },

        // Mvoung
        { id: 35, name: 'Ovan', department_id: 37, province_id: 6 },

        // Zadié
        { id: 36, name: 'Mékambo', department_id: 38, province_id: 6 },

        // === OGOOUÉ-LOLO ===
        // Lolo-Bouenguidi
        { id: 37, name: 'Koulamoutou', department_id: 39, province_id: 7 },

        // Mulundu
        { id: 38, name: 'Lastoursville', department_id: 41, province_id: 7 },

        // Offoué-Onoye
        { id: 39, name: 'Iboundji', department_id: 42, province_id: 7 },

        // Lombo-Bouenguidi
        { id: 40, name: 'Pana', department_id: 40, province_id: 7 },

        // === OGOOUÉ-MARITIME ===
        // Bendjé
        { id: 41, name: 'Port-Gentil', department_id: 43, province_id: 8 },

        // Etimboué
        { id: 42, name: 'Omboué', department_id: 44, province_id: 8 },

        // Ndougou
        { id: 43, name: 'Gamba', department_id: 45, province_id: 8 },

        // === WOLEU-NTEM ===
        // Woleu
        { id: 44, name: 'Oyem', department_id: 50, province_id: 9 },

        // Ntem
        { id: 45, name: 'Bitam', department_id: 48, province_id: 9 },

        // Haut-Ntem
        { id: 46, name: 'Minvoul', department_id: 47, province_id: 9 },

        // Okano
        { id: 47, name: 'Mitzic', department_id: 49, province_id: 9 },

        // Haut-Como
        { id: 48, name: 'Médouneu', department_id: 46, province_id: 9 }
    ]
};

// ==========================================
// FONCTIONS UTILITAIRES
// ==========================================

/**
 * Récupère les départements d'une province donnée
 * @param provinceName - Nom de la province
 * @returns Array des départements de la province
 */
export const getDepartmentsByProvince = (provinceName: string): Department[] => {
    const province = GABON_GEOGRAPHIC_DATA.provinces.find(p => p.name === provinceName);
    if (!province) return [];

    return GABON_GEOGRAPHIC_DATA.departments.filter(d => d.province_id === province.id);
};

/**
 * Récupère les villes d'un département donné
 * @param departmentName - Nom du département
 * @returns Array des villes du département
 */
export const getCitiesByDepartment = (departmentName: string): City[] => {
    const department = GABON_GEOGRAPHIC_DATA.departments.find(d => d.name === departmentName);
    if (!department) return [];

    return GABON_GEOGRAPHIC_DATA.cities.filter(c => c.department_id === department.id);
};

/**
 * Récupère toutes les villes d'une province (utile si aucun département sélectionné)
 * @param provinceName - Nom de la province
 * @returns Array des villes de la province
 */
export const getCitiesByProvince = (provinceName: string): City[] => {
    const province = GABON_GEOGRAPHIC_DATA.provinces.find(p => p.name === provinceName);
    if (!province) return [];

    return GABON_GEOGRAPHIC_DATA.cities.filter(c => c.province_id === province.id);
};

/**
 * Récupère les informations d'un département par son nom
 * @param departmentName - Nom du département
 * @returns Informations du département ou null
 */
export const getDepartmentInfo = (departmentName: string): Department | null => {
    return GABON_GEOGRAPHIC_DATA.departments.find(d => d.name === departmentName) || null;
};

/**
 * Récupère un pays par son nom
 * @param countryName - Nom du pays
 * @returns Informations du pays ou null
 */
export const getCountryByName = (countryName: string): Country | null => {
    return WORLD_COUNTRIES.find(c => c.name === countryName) || null;
};

/**
 * Filtre les pays selon une recherche
 * @param searchTerm - Terme de recherche
 * @returns Array des pays correspondants
 */
export const filterCountries = (searchTerm: string): Country[] => {
    if (!searchTerm.trim()) return WORLD_COUNTRIES;

    const term = searchTerm.toLowerCase();
    return WORLD_COUNTRIES.filter(country =>
        country.name.toLowerCase().includes(term) ||
        country.code.toLowerCase().includes(term)
    );
};
